var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card-wrapper"},_vm._l((4),function(item){return _c('div',{key:item,staticClass:"card_"},[_c('Shimmer',{attrs:{"height":"100%","width":"100%"}})],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }